import {ChipProps} from "@mui/material";
import React from "react";
import {TrackingRecord} from "../../../../shared/models/order/trackingRecord.model";
import moment from "moment";
import BarekamChip from "../../../../components/chip/barekamChip";

export const DurationChip = (props: DurationDiscProps) => {
    const {trackingRecord} = props;

    const latestTrackingRecord = trackingRecord[trackingRecord.length - 1];

    const latestTrackingRecordTime = latestTrackingRecord ? latestTrackingRecord.enteredDate : null

    function determineStatusColor(latestTrackingRecordTime: string) {
        const timeDifference = new Date (new Date().valueOf() - new Date(latestTrackingRecordTime).valueOf());

        if (timeDifference.getDay() > 14) {
            return 3
        } else if (timeDifference.getDay() > 7) {
            return 1
        } else {
            return 2
        }
    }

    if (latestTrackingRecordTime) {
        const statusColor = determineStatusColor(latestTrackingRecordTime);

        return (
            <BarekamChip messageKey={moment(latestTrackingRecordTime).fromNow(true)}
                         statusId={statusColor}
                         chipSize={'s'}/>
        )
    } else {
        return <></>
    }
}

interface DurationDiscProps extends ChipProps{
    trackingRecord: TrackingRecord[];
}
